import React, { Fragment, useEffect, useState } from 'react';
import { Grid, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import { Helmet } from 'react-helmet-async';
import ViewEvent from './ViewEvent';

const EventManagement = () => {
    const navigate = useNavigate();
    
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (Object.keys(user).length === 0) {
            navigate('/');
        }else{
            setIsLoading(false);
        }
    }, [navigate]);

    return (
        <Fragment>
        <Helmet>
            <title>Events</title>
        </Helmet>

        <Container maxWidth="xl">
            <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={3}
            >
            {!isLoading  &&
                <Grid item xs={12}>
                   <ViewEvent/>
                </Grid>
            }
            </Grid>
            <SnackBar />
        </Container>
        </Fragment>
    );
};

export default EventManagement;
